export class WorkerCoordinates
{
    public MemberId: number;
    public BusinessId: number;
    public Latitude: number;
    public Longitude: number;
    public Timestamp: number;
    public Time: string;
    
    constructor(
        MemberId: number,
        BusinessId: number,
        Latitude: number,
        Longitude: number,
        Timestamp: number,
        Time: string
    ){
        this.MemberId = MemberId;
        this.BusinessId = BusinessId;
        this.Latitude = Latitude;
        this.Longitude = Longitude;
        this.Timestamp = Timestamp;
        this.Time = Time;
    }
}